{
	"title": "Comentarios",
	"statuses": {
		"inValidation": "En Validación",
		"rejected": "Rechazado",
		"assured": "Seguro",
		"flagged": "Marcado",
		"resolved": "Resuelto"
	}
}
